import { arrow, closeIcon } from "@/designSystemIcons";
import { formatSbcSetName } from "@/pages/Sbcs/SbcSetPage/SbcSetPage";
import React from "react";
import { useNavigate } from "react-router";

type Props = {
  showFiltersBar?: boolean;
  setShowFiltersBar?: (v: boolean) => void;
  name?: string;
  filtersTitle?: string | React.ReactNode;
  showCloseIcon?: boolean;
};

const MobileHeaderBar: React.FC<Props> = ({
  showFiltersBar = false,
  setShowFiltersBar,
  filtersTitle = "SBC Solution Filters",
  showCloseIcon = true,
  name,
}) => {
  const navigate = useNavigate();

  const handleBack = () => {
    if (showFiltersBar && setShowFiltersBar) {
      setShowFiltersBar(false);
    } else {
      navigate("/");
    }
  };

  return (
    <div className="h-12 bg-panel-base flex items-center">
      <div className="flex justify-between items-center w-full">
        <div className="p-4" onClick={handleBack}>
          <div className="w-3 h-3 rotate-90 flex items-center text-dark-tertiary">
            {arrow}
          </div>
        </div>
        <h1 className="text-sm font-semibold text-center">
          {showFiltersBar
            ? filtersTitle
            : "EA FC 25 SBC Solution" + " - " + formatSbcSetName(name)}
        </h1>
        <div
          className="flex items-center p-4"
          onClick={() => showFiltersBar && setShowFiltersBar?.(false)}
        >
          {showFiltersBar && showCloseIcon ? (
            closeIcon
          ) : (
            <div className="w-4 h-4" />
          )}
        </div>
      </div>
    </div>
  );
};

export default MobileHeaderBar;
